// One business briefing: the list that went to the phone, the written
// version, and (on the Briefings page) the numbers it was written from.
import { Pill } from '../lib/ui';
import { formatWhen, paragraphs, snapshotSections } from '../lib/briefings';
import './Briefings.css';

export function SourcePill({ briefing }) {
  if (briefing.status === 'running') return <Pill tone="blue">Being written</Pill>;
  if (briefing.status === 'failed') return <Pill tone="bad">Failed</Pill>;
  if (briefing.source === 'numbers') return <Pill tone="warn">Numbers only</Pill>;
  return <Pill tone="ok">{briefing.model || 'AI'}</Pill>;
}

function pushText(push) {
  if (!push?.requested) return 'Not sent to the phone';
  if (push.ok) return `Sent to ntfy (${push.topic})`;
  return `Phone push failed${push.status ? ` (${push.status})` : ''}${push.error ? `: ${push.error}` : ''}`;
}

export function NumbersPanel({ snapshot }) {
  const sections = snapshotSections(snapshot);
  if (!sections.length) return null;
  return (
    <details className="br-numbers">
      <summary>The numbers it was written from</summary>
      <div className="br-numbers__grid">
        {sections.map(s => (
          <section key={s.key} className="br-numbers__section">
            <h4>{s.title}</h4>
            {s.rows.map((r, i) => (
              <div key={i} className={`br-row${r.value === '' ? ' br-row--head' : ''}`} style={{ paddingLeft: r.depth * 12 }}>
                {r.label && <span className="br-row__label">{r.label}</span>}
                <span className="br-row__value">{r.value}</span>
              </div>
            ))}
          </section>
        ))}
      </div>
    </details>
  );
}

export default function BriefingView({ briefing, showNumbers = false }) {
  if (briefing.status === 'running') {
    return <p className="br-note br-note--info">Being written on server3. This usually takes two to five minutes.</p>;
  }
  const minutes = briefing.ai?.ms ? Math.max(1, Math.round(briefing.ai.ms / 60000)) : null;
  return (
    <div className="br-view">
      {briefing.bullets?.length > 0 && (
        <ul className="br-bullets">
          {briefing.bullets.map((b, i) => <li key={i}>{b}</li>)}
        </ul>
      )}
      {briefing.source === 'ai' && (
        <div className="br-prose">
          {paragraphs(briefing.briefing).map((p, i) => <p key={i}>{p}</p>)}
        </div>
      )}
      {briefing.error && (
        <p className={`br-note ${briefing.source === 'ai' ? 'br-note--info' : 'br-note--warn'}`}>
          {briefing.source === 'numbers' || briefing.status === 'failed'
            ? `The model on server3 couldn't write this one: ${briefing.error}.`
            : briefing.error}
        </p>
      )}
      <div className="br-meta">
        {briefing.from && <span>Covers {formatWhen(briefing.from)} to {formatWhen(briefing.to)}</span>}
        <span>{pushText(briefing.push)}</span>
        {minutes && <span>Took {minutes} min on server3</span>}
      </div>
      {showNumbers && briefing.snapshot && <NumbersPanel snapshot={briefing.snapshot} />}
    </div>
  );
}
